import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class GetusuariosService {

  constructor() { 

  }

  public array_usuarios:Usuarios[]=[];

  public async getUsuarios(carer: string){
    //Cargamos la apirest de Amplify
    // console.log("API - GETUSUARIOS:");
    const response = await this.getData(carer); 
    return response.data.Items; // Valor que devolvemos
  }


  public getData(carer: string) { 
    const apiName = 'PharaonAmicareUsersApi';
    const path = '/users';
    const myInit = { // OPTIONAL
      headers: {     
        'Content-Type': 'application/json'
      }, // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {  // OPTIONAL
        carer: carer,

      },
  };

    return API.get(apiName, path, myInit);

  }

}

export interface Usuarios{
  carer: string;
  userid : string;
  useridCETEM : string;
  nombre : string;
  apellidos : string;
  disp1 : string;
  disp2 : string;
  disp3 : string;
  estadoDisp1: boolean;
  estadoDisp2: boolean;
  estadoDisp3: boolean;
  patient: string;
  idPatient: string;
  dni: string; 
  tokenFCM: string; 
  
}